import * as API from '@/api';
import {getField, updateField} from 'vuex-map-fields';

//initial state
function initialState () {
  return {
    profile: null
  };
}
const state = initialState ();

// actions

const actions = {
  async subscribeNewsletter(context, payload) {
    var response = await API.consumer.subscribeNewsletter(payload);
    return response;
  },
};

// getters
const getters = {
  getField
};

// mutations
const mutations = {
  updateField,
  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
